import { ISchool } from 'types'
import { IPlaceOption } from 'types/IPlaceOption'

export const basicsInitialState = {
  user: {
    avatar: '',
    firstName: '',
    lastName: '',
    currentRole: '',
    currentCompany: '',
    schools: [] as ISchool[],
    hometownLocation: {} as IPlaceOption
  },
  schools: {
    options: [] as { label: string; value: string }[],
    isSearching: false
  }
}

export type BasicsState = typeof basicsInitialState
